jQuery(document).ready(function ($) {
	//Controls how the message is closed with the close button/link
	function HideMessage()
	{
		$('.c-site-notice').fadeOut(400);
		var currentTime = Math.floor(Date.now() / 1000);
		var siteNotice = {
			message: $('.c-site-notice').html(),
			time: currentTime,
			clicked: true
		};
		localStorage.setItem("siteNoticeJSON", JSON.stringify(siteNotice));
	}

	function displaySiteNotice() {
        $('.c-site-notice').fadeIn(400);
        if ($('.c-site-notice').hasClass('active')) {
            $('.c-site-header').addClass('c-site-header__message-active')
			$('body').addClass('message-active')
            $('.l-layout').addClass('l-layout__message-active')
        }
  
	    $('.c-site-notice__close').click(function () {
           HideMessage();
           $('.c-site-header').removeClass('c-site-header__message-active')
		   $('body').removeClass('message-active')
           $('.l-layout').removeClass('l-layout__message-active')
	    });  
	}



	function checkSiteNotice() {
		if (localStorage.getItem("siteNoticeJSON")) {
			try {
				var siteNoticeTimeout = 86400; //24 hours
				var siteNotice = $('.c-site-notice').html();
				var currentTimestamp = Math.floor(Date.now() / 1000);
				var siteNoticeData = JSON.parse(localStorage.getItem("siteNoticeJSON"));
				if (siteNoticeData) {
					if (siteNotice == siteNoticeData.message && currentTimestamp - siteNoticeData.time < siteNoticeTimeout) {		
						return;
					}
				}
			} catch(e) {
				console.error(e);
			}
        }
        displaySiteNotice();
    
	}
    
    checkSiteNotice();
    
});